import {Button} from '@mui/material';
import type {ApiErrorCode} from '@perfectpost/perfect-post-common';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {apiFailureActionFor} from '../utils/apiFailure';

/**
 * Le bouton d'un refus de l'API affiché en snackbar — le pendant d'`ApiFailureAlert`
 * pour les refus qui n'ont pas d'emplacement dans la vue (glisser-déposer, suppression
 * depuis une liste).
 *
 * ⚠️ notistack rend ce composant dans SON conteneur, qui ne voit que les contextes situés
 * au-dessus de `SnackbarProvider` (cf. `App.tsx`) : le routeur, mais pas
 * `TeamSelectionProvider`. D'où l'absence de l'action `teamSettings`, qui a besoin de
 * l'équipe courante : le message du serveur suffit à dire quoi faire.
 */
export function ApiFailureSnackbarAction({code}: {code: ApiErrorCode}) {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const button = ((): {label: string; to: string} | undefined => {
    switch (apiFailureActionFor(code)) {
      case 'upgrade':
        return {label: t('pageAccess.action.upgrade'), to: '/settings/subscription'};
      case 'reconnect':
        return {label: t('pageAccess.action.reconnect'), to: '/settings'};
      default:
        return undefined;
    }
  })();

  if (button === undefined) {
    return <></>;
  }
  return (
    <Button color="inherit" size="small" sx={{whiteSpace: 'nowrap'}} onClick={() => navigate(button.to)}>
      {button.label}
    </Button>
  );
}
